import { IUserNotification, UserNotificationType } from '@migrate/stores/UserNotificationStore'
import { getUserNotificationStore } from '@migrate/stores'

export const addNotification = (
  type: UserNotificationType,
  messageCode: string,
  additionalOptions?: IUserNotification['additionalOptions'],
) => {
  getUserNotificationStore().addNotification(type, messageCode, additionalOptions)
}
